"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        root: function (_a) {
            var fullWidth = _a.fullWidth, bgColor = _a.bgColor, isSelected = _a.isSelected, selectedBgColor = _a.selectedBgColor, setPadding = _a.setPadding, hoverColor = _a.hoverColor;
            return ({
                display: 'flex',
                flexDirection: 'column',
                padding: !setPadding ? 0 : '10px',
                flexWrap: 'nowrap',
                position: 'relative',
                width: fullWidth ? '100%' : undefined,
                backgroundColor: isSelected ? selectedBgColor : bgColor,
                '&:hover > div > svg > path': {
                    stroke: hoverColor !== null && hoverColor !== void 0 ? hoverColor : '',
                    strokeWidth: hoverColor ? 3 : '',
                },
            });
        },
        icon: function (_a) {
            var _b = _a.iconWidth, iconWidth = _b === void 0 ? 32 : _b, _c = _a.iconHeight, iconHeight = _c === void 0 ? 32 : _c;
            return ({
                display: 'flex',
                width: iconWidth,
                height: iconHeight,
            });
        },
        label: function (_a) {
            var color = _a.color, isSelected = _a.isSelected, selectedColor = _a.selectedColor, disabled = _a.disabled;
            return disabled
                ? {
                    color: theme.palette.action.disabled,
                }
                : {
                    color: isSelected ? selectedColor : color,
                };
        },
        typography: function (_a) {
            var isSelected = _a.isSelected;
            return isSelected
                ? {
                    fontWeight: 'bold',
                }
                : {};
        },
    });
});
